module.exports = __webpack_public_path__ + "img/laranja_brasao.2bd0075d.png";